<template>
  <g>
    <path
      d="M13.0882 5.00037C12.8574 5.0071 12.6382 5.1034 12.4771 5.26889L7.10211 10.6439L4.46321 8.60222C4.21326 8.39073 3.8673 8.33376 3.56274 8.45392C3.25818 8.57408 3.04431 8.85192 3.00609 9.17709C2.96787 9.50226 3.11149 9.82212 3.37989 10.0096L6.63915 12.5281C6.99385 12.8001 7.49531 12.7664 7.81044 12.4494L13.7364 6.52351C13.9974 6.26735 14.075 5.87744 13.9317 5.5409C13.7885 5.20435 13.4538 4.98986 13.0882 5.00037V5.00037Z"
    />
  </g>
</template>
